import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";

// custom components
import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import RefreshButton from "components/common/buttons/RefreshButton";
import { crudGetList as crudGetListAction } from "store/actions/dataActions";

/**
 * material-dashboard-pro-react-v1.5.0 > AdminNavbarLinks.jsx(HeaderLinks.jsx) 참고
 * v1.5.0에서 AdminNavbarLinks.jsx로 변경됨
 */
class HeaderLinks extends React.Component {
  componentDidMount() {
    console.log("HeaderLinks - componentDidMount");
  }

  // 리렌더링이 불필요한 케이스 정의
  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.topMenu === this.props.topMenu &&
      nextProps.companyName === this.props.companyName
    ) {
      console.log("HeaderLinks - shouldComponentUpdate : false");
      return false;
    }
    console.log("HeaderLinks - shouldComponentUpdate : true");
    return true;
  }

  renderLink = linkUrl => props => {
    return <Link to={linkUrl} {...props} />;
  };

  render() {
    const {
      classes,
      isSmallScreen
    } = this.props;

    return (
      <div className={"header-link-fix"}>
        {/* 새로고침 */}
        {isSmallScreen && (
          <div className={"refreshButtonContainer"}>
            <RefreshButton
              buttonProps={{
                color: "transparent",
                simple: true,
                //justIcon: true,
                className: classes.buttonLink + " refreshButton-sidemenu"
              }}
              iconProps={
                {
                  //className: classes.headerLinksSvg + " " + classes.links
                }
              }
            >
              <div className={"refreshButton-label"}>
                <FormattedMessage id="common.refresh" />
              </div>
            </RefreshButton>
          </div>
        )}

        {/* 새로고침 */}
        {isSmallScreen || (
          <FormattedMessage id="common.refresh">
            {title => (
              <Tooltip title={title} placement="bottom">
                <span>
                  <RefreshButton
                    buttonProps={{
                      color: "transparent",
                      simple: true,
                      "aria-label": title,
                      justIcon: true,
                      className: classes.buttonLink + " button-link-fix"
                    }}
                    iconProps={{
                      className: classes.headerLinksSvg + " " + classes.links
                    }}
                  />
                </span>
              </Tooltip>
            )}
          </FormattedMessage>
        )}
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  source: PropTypes.string,
  topMenu: PropTypes.string.isRequired
};

export default compose(
  withStyles(headerLinksStyle),
  connect(
    state => ({
      menu: "header_auth",
      refreshVersion: state.main.refreshVersion,
    }),
    {
      dispatchCrudGetList: crudGetListAction
    }
  )
)(HeaderLinks);
